<template>
  <v-container>
    <Diccionario :id_unit="this.idUnidad" :isPractice="true"/>
    <v-layout>
      <v-flex xs12>
        <CardDragLine 
          :idUnidad="this.idUnidad" 
          :textSpanish="loadedLessons.instructions_spanish"
          :textExercise="loadedLessons.exercise"
          :options="loadedLessons.options"
          />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import CardDragLine from '../../../components/Practica/intermedio/CardDragLine'
import { storeFirebase } from '../../../store/firebase'
export default {
  name: 'PracticaDragLine',
  props: ['idUnidad'],
  components: {
    CardDragLine
  },
  created () {
    this.loadLessons()
  },
  computed: {
    loadedLessons () {
      const dataValues = storeFirebase.getters.loadedPracticeLessons
      const data = dataValues.filter(data => data.id_tipo_ejercicio == 4)
      return data[0]
    }
  },
  methods: {
    loadLessons () {
      const payload = {
        id_unit: Number(this.idUnidad),
        id_practice: 1
      }
      storeFirebase.dispatch("loadPracticeLessons", payload)
    }
  }
}
</script>
